import { useState } from 'react';

const useFileValidator = () => {
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
  const [error, setError] = useState<string | null>(null);

  const validateFile = (file: File | null) => {
    if (!file) {
      setError('파일을 선택해주세요.');
      return false;
    }

    const extension = file.name.split('.').pop()?.toLowerCase(); // 파일 이름에서 확장자 추출
    if (!extension || !allowedExtensions.includes(extension)) {
      setError('허용되지 않는 파일 형식입니다.');
      return false;
    }
    
    setError(null);
    return true;
  };

  return {
    error,
    validateFile,
  };
};

export default useFileValidator;
